import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Modal } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { getExceptionTypes, getMaterials, getSubElements } from '~/store/manager/actions';
import { getExpediteMaterials, cleanExpediteDailyPartsList } from '~/store/expedite/actions';
import SearchHeader from './SearchHeader';
import ExpediteReport from './ExpediteReport';
import SearchForm from './SearchForm';
import styles from './styles';

const ExpediteDailyPartsTab = ({ classes }) => {
  const [modalOpen, setModalOpen] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getMaterials({ all: true }));
    dispatch(getSubElements({ all: true }));
    dispatch(getExpediteMaterials());
    dispatch(getExceptionTypes());
  }, [dispatch]);

  useEffect(() => () => {
    dispatch(cleanExpediteDailyPartsList());
  }, [dispatch]);

  const handleModalClose = () => {
    setModalOpen(false);
  };

  return (
    <div className={classes.container}>
      <SearchHeader setOpenModal={setModalOpen} />
      <ExpediteReport />
      <Modal
        open={modalOpen}
        onBackdropClick={handleModalClose}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <SearchForm onSearch={handleModalClose} onClose={handleModalClose} />
        </div>
      </Modal>
    </div>
  );
};

ExpediteDailyPartsTab.propTypes = {
  classes: PropTypes.object.isRequired,
};

ExpediteDailyPartsTab.defaultProps = {};

export default withStyles(styles)(ExpediteDailyPartsTab);
